import EmailPhoneContact from './shared/EmailPhoneContact'

const GiftsReceivedDelay = () => (
  <span>Gifts may take a few days to appear in the My Giving Gateway. If you have questions regarding your giving,
    <EmailPhoneContact/>
  </span>
)

export default GiftsReceivedDelay